import React from 'react';
import ReactDOM from 'react-dom/client';

import '@fontsource/kanit/400.css';
import '@fontsource/montserrat/400.css';

import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
